export default __webpack_public_path__ + "static/media/list-icon.db5c0bbd.svg";